export const HACKED_TOGETHER_PROPERTY_IDS = {
  dev: {
    TheHartwell: '888b5845-7a66-4f60-8c5c-dd66808f4888',
  },
  prod: {
    TheDockery: '70a43dd7-1cbe-4d44-a9eb-17d8eb6cce0f',
  },
  staging: {
    TheDockery: 'b7e669bc-263e-4633-b43f-a49e4b09d415',
  },
};
